import { useMemo } from 'react'

import { Option } from '@joor/design-system'

import { BrandStartOrderIds } from 'modals/OrderList/StartOrderModal/StartOrderModal.ids'

import { getDesignSystemOptionId } from '../../BrandStartOrderModal.formatters'
import messages from '../../BrandStartOrderModal.messages'
import { StyledDropdown } from './OrderTypeDropdown.styles'

interface OrderTypeDropdownProps {
  options: Option[]
  value: string | null | undefined
  setSelectedOrderTypeId: (orderTypeId: string | null) => void
}

export const OrderTypeDropdown = ({
  options,
  value,
  setSelectedOrderTypeId,
}: OrderTypeDropdownProps) => {
  const selectedOption = useMemo(
    () =>
      options.find((option) => getDesignSystemOptionId(option) === value) ??
      null,
    [options, value],
  )

  const handleSelect = ({ selected }: { selected: Option }) => {
    setSelectedOrderTypeId(getDesignSystemOptionId(selected))
  }

  return (
    <StyledDropdown
      id={BrandStartOrderIds.OrderTypesOptions}
      testId={BrandStartOrderIds.OrderTypesOptions}
      labelId={BrandStartOrderIds.OrderTypesTitle}
      label={messages.selectOrderType}
      options={options}
      value={selectedOption}
      translateOptions={false}
      onSelect={handleSelect}
      placeholder={messages.selectOne}
    />
  )
}
